import axiosInstance from '@/services/api/axiosInstance';

/**
 * A re-run support ordered and asked the client to pay for.
 *
 * Support sends an SMS with a link to /rerun/:id. This is what that page
 * reads and what its pay button calls — a separate, single-purpose endpoint
 * rather than the consultation checkout, because the amount is one SUPPORT
 * set per case and the thing being bought is one more attempt, not a service.
 */

/** GET /user/reruns/:id — what is being re-done, for how much, and by which gateways. */
export async function getRerun(rerunId) {
  const res = await axiosInstance.get(`/user/reruns/${encodeURIComponent(rerunId)}`);
  return res.data.data?.rerun ?? res.data.data ?? res.data;
}

/**
 * POST /user/reruns/:id/pay — start the gateway.
 *
 * Only the code is sent, never a price: the server re-quotes the discount
 * against the amount it stored, so the figure charged is its own.
 */
export async function payRerun(rerunId, gateway, discountCode) {
  const res = await axiosInstance.post(`/user/reruns/${encodeURIComponent(rerunId)}/pay`, {
    gateway: gateway || undefined,
    discountCode: discountCode || undefined,
  });
  return res.data.data ?? res.data;
}

export const rerunsApi = { getRerun, payRerun };
export default rerunsApi;
